var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#2878FF;}\r\n\t.st4{fill:#1EC0FF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1",
    className: "st0"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32_4X24\\u80CC\\u666F",
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_6X16\\u80CC\\u666F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u53C2\\u8003"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible",
      enableBackground: "new"
    },
    width: 788,
    height: 599,
    xlinkHref: "CA1D416E.jpg",
    transform: "matrix(6.302754e-02 0 0 6.302754e-02 -12.8329 -9.8767)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible",
      enableBackground: "new"
    },
    width: 782,
    height: 657,
    xlinkHref: "CA1D416B.jpg",
    transform: "matrix(3.041902e-02 0 0 3.335176e-02 29.6062 -20.8437)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_px\\u53C2\\u8003\\u7EBF",
    className: "st1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_6\\u5B89\\u5168\\u7F51\\u683C"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_4\\u5B89\\u5168\\u7F51\\u683C",
    className: "st1"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_4\\u5B89\\u5168\\u7F51\\u683C2"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_8"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_9",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6,9.1c0-0.4,0.2-0.7,0.5-0.9l5-2.9c0.3-0.2,0.7-0.2,1,0l3.6,2.1l0,0l5.9,3.4v-4c0-0.4-0.2-0.7-0.5-0.9 l-9-5.2c-0.3-0.2-0.7-0.2-1,0l-9,5.2C2.2,6.1,2,6.4,2,6.8v2.5l4,2.3V9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18,14.9c0,0.4-0.2,0.7-0.5,0.9l-5,2.9c-0.3,0.2-0.7,0.2-1,0l-4.4-2.5l-5.1-3v4c0,0.4,0.2,0.7,0.5,0.9 l9,5.2c0.3,0.2,0.7,0.2,1,0l9-5.2c0.3-0.2,0.5-0.5,0.5-0.9v-2.5l-4-2.3V14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.7,10.8c0-0.2-0.1-0.5-0.3-0.6l-2-1.2c-0.2-0.1-0.5-0.1-0.7,0l-2,1.2c-0.2,0.1-0.3,0.3-0.3,0.6v2.3 c0,0.2,0.1,0.5,0.3,0.6l2,1.2c0.2,0.1,0.5,0.1,0.7,0l2-1.2c0.2-0.1,0.3-0.3,0.3-0.6V10.8z"
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6,9.1c0-0.4,0.2-0.7,0.5-0.9l5-2.9c0.3-0.2,0.7-0.2,1,0l3.6,2.1l0,0l5.9,3.4v-4c0-0.4-0.2-0.7-0.5-0.9l-9-5.2 c-0.3-0.2-0.7-0.2-1,0l-9,5.2C2.2,6.1,2,6.4,2,6.8v2.5l4,2.3V9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M18,14.9c0,0.4-0.2,0.7-0.5,0.9l-5,2.9c-0.3,0.2-0.7,0.2-1,0l-4.4-2.5l-5.1-3v4c0,0.4,0.2,0.7,0.5,0.9l9,5.2 c0.3,0.2,0.7,0.2,1,0l9-5.2c0.3-0.2,0.5-0.5,0.5-0.9v-2.5l-4-2.3V14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.7,10.8c0-0.2-0.1-0.5-0.3-0.6l-2-1.2c-0.2-0.1-0.5-0.1-0.7,0l-2,1.2c-0.2,0.1-0.3,0.3-0.3,0.6v2.3 c0,0.2,0.1,0.5,0.3,0.6l2,1.2c0.2,0.1,0.5,0.1,0.7,0l2-1.2c0.2-0.1,0.3-0.3,0.3-0.6V10.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.75e8ffdba2c42f902a433fe1ab951523.svg";
export { ForwardRef as ReactComponent };